import store from '../store'

export default async function (to, from, next) {
    if (!store.getters.GET_IS_LOGGET) {
        await store.dispatch('A_ME')
        if (store.getters.GET_IS_LOGGET === true) {
            next()
        } else {
            next('/auth/login')
        }
    } else {
        next()
    }
}
